import React, { ReactNode, forwardRef } from 'react';

/**
 * @typedef {SlideWrapperProps}
 * @property {ReactNode} children
 * @property {string} id the DOM element ID for the slide
 */
interface SlideWrapperProps {
    children: ReactNode;
    id: string;
}

/**
 * A wrapper that provides the necessary ref for useIntersectionObserver to implement imperative
 * scrolling.
 * @param {SlideWrapperProps} props
 */
export const SlideWrapper = forwardRef<HTMLDivElement, SlideWrapperProps>(
    ({ children, id }, ref): JSX.Element | null => (
        <div ref={ref} className="flex-none" id={id}>
            {children}
        </div>
    ),
);

SlideWrapper.displayName = 'SlideWrapper';
